<!--Copyright (c) PikPok. All rights reserved-->
<template>
  <v-container :fluid="true" class="ma-0 pa-0" v-if="loading">
    <v-row class="text-white bg-yellow-darken-3 pa-3 mt-0">
      <router-link to="/privacy">
        <v-icon color="white" icon="mdi-less-than" size="x-large" class="pr-5 pl-5"></v-icon>
      </router-link>
      <v-icon color="white" icon="mdi-trash-can-outline" size="x-large" class="pr-5 pl-5"></v-icon>
      <h3 class="mt-1">{{ localeKeys.strings.PRIVACY_ERASE }}</h3>
    </v-row>

    <v-row v-if="!formSubmit">
      <v-col offset-lg="2" lg="8" offset="1" cols="10">
        <v-form ref="form" lazy-validation>
          <v-text-field
              v-model="formDetails.name"
              :rules="[v => !!v]"
              :label=localeKeys.strings.BUG_NAME
              :placeholder=localeKeys.strings.BUG_NAME_HINT
              required variant="solo-filled"
          ></v-text-field>
          <v-text-field
              v-model="formDetails.email"
              :rules="[v => !!v, v => !v || /\s*\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})\s*/.test(v)]"
              :label=localeKeys.strings.BUG_EMAIL
              :placeholder=localeKeys.strings.BUG_EMAIL_HINT
              required variant="solo-filled"
          ></v-text-field>
          <v-text-field
              v-model="formDetails.advertisingid"
              :rules="[v => !!v]"
              :label=localeKeys.strings.PRIVACY_ID
              :placeholder=localeKeys.strings.PRIVACY_ID_HINT
              required variant="solo-filled"
          ></v-text-field>
          <!-- How to find Advertising ID -->
          <v-expansion-panels class="mb-5">
            <v-expansion-panel>
              <v-expansion-panel-title class="text-subtitle-1 bg-amber-lighten-4">
                {{ localeKeys.strings.PRIVACY_HOW_FIND }}
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <h3>{{ localeKeys.strings.PRIVACY_APPLE }}</h3>
                <p>{{ localeKeys.strings.PRIVACY_IDFA }}</p>
                <ul>
                  <li>
                    <a href="https://itunes.apple.com/us/app/my-device-id-by-appsflyer-whitelist-test-device/id1192323960" target="_blank">
                      My Device IFDA by AppsFlyer
                    </a>
                  </li>
                  <li>
                    <a href="https://itunes.apple.com/us/app/adjust-insights/id1125517808" target="_blank">
                      Adjust Insights by Adjust
                    </a>
                  </li>
                  <li>
                    <a href="https://itunes.apple.com/us/app/my-tune-device/id1100377074" target="_blank">My TUNE Device by Tune</a>
                  </li>
                </ul>
                <h3 class="mt-3">{{ localeKeys.strings.PRIVACY_ANDROID }}</h3>
                <p>{{ localeKeys.strings.PRIVACY_AAI }}</p>
                <p>
                  {{ localeKeys.strings.PRIVACY_THIRD_PARTY }}
                  <a href="https://play.google.com/store/apps/details?id=tech.simplycode.deviceadvertisingid">
                    Device Google Advertising Identifier Viewer
                  </a>
                  {{ localeKeys.strings.PRIVACY_CLIPBOARD }}
                </p>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-text-field
              type="number"
              v-model="formDetails.currentid"
              :rules="[v => !!v]"
              :label=localeKeys.strings.PRIVACY_PP_ID
              :placeholder=localeKeys.strings.PRIVACY_PP_ID_HINT
              required variant="solo-filled"
          ></v-text-field>
          <!-- How to find PikPokPlus ID -->
          <v-expansion-panels class="mb-5">
            <v-expansion-panel>
              <v-expansion-panel-title class="text-subtitle-1 bg-amber-lighten-4">
                {{ localeKeys.strings.PRIVACY_HOW_FIND }}
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <b>Breakneck</b>
                <ul>
                  <li>Tap on the Gear icon in the lower left hand corner of the main screen</li>
                  <li>Tap on the Credits icon to the left of the screen</li>
                </ul>
                <p>Your PikPokPlus ID should appear in the lower right, as a long string of numbers</p>

                <b>Doomsday Clicker</b>
                <ul>
                  <li>Tap on the Gear icon in the lower right hand corner of the main screen</li>
                </ul>
                <p>Your PikPokPlus ID should appear in the lower right of the settings window, as a long string of
                  numbers</p>

                <b>Dungeon, Inc.</b>
                <ul>
                  <li>Tap on the Gear icon in the upper left hand corner of the main screen</li>
                </ul>
                <p>Your PikPokPlus ID should appear in the lower right of the settings window, as a long string of
                  numbers</p>

                <b>Flick Kick Football Legends</b>
                <ul>
                  <li>Tap on the Gear icon in the lower right hand corner of the main screen</li>
                  <li>Tap on the Credits icon 2nd to the right on the bottom of the screen</li>
                </ul>
                <p>Your PikPokPlus ID should appear in the lower left of the screen, as a long string of numbers</p>

                <b>Four Letters</b>
                <ul>
                  <li>Tap on the Menu button on the lower left of the screen</li>
                  <li>Tap on the Settings icon on the bottom right corner of the screen</li>
                  <li>Tap on the Credits icon</li>
                </ul>
                <p>Your PikPokPlus ID should appear on the bottom right of the screen, as a long string of numbers</p>

                <b>Glow Worm Adventure</b>
                <ul>
                  <li>Tap on the Menu icon in the top left corner of the screen to show the menu options</li>
                  <li>Tap on the red Credits icon</li>
                </ul>
                <p>Your PikPokPlus ID should appear near the middle of the screen, as a long string of numbers under the
                  Player heading</p>

                <b>Into the Dead</b>
                <ul>
                  <li>Tap on the Setting icon on the bottom right corner</li>
                  <li>Tap on the Credits icon, third from the right</li>
                </ul>
                <p>Your PikPokPlus ID should appear in the top left corner of the screen, as a long string of
                  numbers</p>

                <b>Into the Dead 2</b>
                <ul>
                  <li>Tap on the Settings icon in the bottom left hand corner of the screen.</li>
                </ul>
                <p>Your PikPokPlus ID should appear in the bottom right corner of the screen, as a long string of
                  numbers</p>

                <b>Maze Runner: The Scorch Trials</b>
                <ul>
                  <li>Tap on the Main Menu button on the top left of the screen</li>
                  <li>Tap on the Settings Button on the lower left of the screen</li>
                </ul>
                <p>Your PikPokPlus ID should be shown at the bottom of the screen, above the close button</p>

                <b>Monsters Ate My Metropolis</b>
                <ul>
                  <li>Tap on the Mail icon on the top left corner of the screen</li>
                  <li>Tap on the Settings icon on the bottom right corner of the screen</li>
                </ul>
                <p>Your PikPokPlus ID should appear in the bottom right of the settings window, as a long string of
                  numbers</p>

                <b>Rival Stars Basketball</b>
                <ul>
                  <li>Tap on the Mail icon on the bottom left corner of the screen</li>
                  <li>Tap on the Settings icon the upper right of the screen, next to the controls icon</li>
                  <li>Tap on the Credits button</li>
                </ul>
                <p>Your PikPokPlus ID should appear in the top right of the screen, as a long string of numbers</p>

                <b>Rival Stars College Football</b>
                <ul>
                  <li>Tap on the Campus icon in the lower left hand corner of the main screen</li>
                  <li>Tap on the Inbox/Setting icon on the lower left of the map</li>
                  <li>Tap on the Options tab on the upper right of the screen</li>
                </ul>
                <p>Your PikPokPlus ID should appear in the lower left of the Options window, as a long string of
                  numbers</p>

                <b>Shadow Wars</b>
                <ul>
                  <li>Tap on the Main Menu button on the top left of the screen</li>
                  <li>Tap on the Settings Button on the lower left of the screen</li>
                </ul>
                <p>Your PikPokPlus ID should be shown at the bottom of the screen, above the close button</p>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- Captcha -->
          <v-row class="mt-2 mb-2">
            <v-col cols="12" :style="captchaError ? 'color: red' : null ">
              <h3>{{ localeKeys.strings.PRIVACY_CAPTCHA }}</h3>
            </v-col>
            <v-col sm="7" md="6" class="captcha ml-2">
              <template v-for="(char, index) in captchaChars" :key="index">
                <span class="captcha-char"
                      :style="{ fontSize: char.fontSize + 'px', transform: 'rotate(' + char.rotation + 'deg)' }">
                  {{ char.char }}
                </span>
              </template>
            </v-col>
            <v-col sm="4">
              <v-icon icon="mdi-refresh" size="x-large" class="pr-5 pl-5"
                      @click="generateUUIDCaptcha">
              </v-icon>
            </v-col>
          </v-row>
          <v-text-field
              v-model="captcha"
              :label=localeKeys.strings.BUG_ANSWER
              :placeholder=localeKeys.strings.BUG_ANSWER
              :rules="[v => !!v]"
              required variant="solo-filled">
          </v-text-field>
          <!-- Hidden fields -->
          <v-text-field v-model="formDetails.hash_type" v-show="false"></v-text-field>
          <v-text-field v-model="formDetails.hash_value" v-show="false"></v-text-field>
          <!-- Privacy aware note -->
          <div class="bg-amber-lighten-4 pa-5">
            <h3>{{ localeKeys.strings.PRIVACY_BE_AWARE }}</h3>
            <p class="pt-2">{{ localeKeys.strings.PRIVACY_AWARE_SUBMIT }}</p>
          </div>
          <v-btn
              color="yellow-darken-3"
              class="mt-4 mb-5 text-white"
              block
              @click="submit()">
            {{ localeKeys.strings.BUG_SUBMIT }}
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
    <!-- Success or Error response after submit -->
    <v-row v-else class="mt-10">
      <v-col offset-lg="2" lg="8" offset="1" cols="10">
        <p v-if="error">{{ localeKeys.strings.PRIVACY_ERROR }}</p>
        <p v-else>{{ localeKeys.strings.PRIVACY_THANKS }}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
  name: "PrivacyForm",
  components: {},
  data() {
    return {
      loading: false,
      formDetails: {
        name: '',
        email: '',
        advertisingid: '',
        currentid: '',
        hash_type: '',
        hash_value: ''
      },
      formSubmit: false,
      error: false,
      captcha: null,
      captchaChars: null,
      captchaError: false
    }
  },
  computed: {
    ...
        mapState({
          localeKeys: state => state.supportStore.localeKeys,
        }),
  },
  mounted() {
    this.getLocaleKeys().then(() => {
      this.loading = true
    })
    this.generateUUIDCaptcha()
    this.getQueryParams()
  },
  methods: {
    generateUUIDCaptcha() {
      let characters = '123456789'
      let chars = characters.split('')
      let captchaChars = []
      for (let i = 0; i < 6; i++) {
        let char = chars[Math.floor(Math.random() * chars.length)]
        let fontSize = Math.floor(Math.random() * 10) + 30 // random font size
        let rotation = Math.floor(Math.random() * 21) - 20 // random rotation
        captchaChars.push({char, fontSize, rotation})
      }
      this.captchaChars = captchaChars
    },

    getQueryParams() {
      let res = {}
      Object.keys(this.formDetails).forEach(k => res[k] = (this.$route.query[k] ?? this.formDetails[k]))
      this.formDetails = res
      if (this.$route.query['hashedid']) this.formDetails['hash_value'] = this.$route.query['hashedid']
      if (this.$route.query['type']) this.formDetails['hash_type'] = this.$route.query['type']
    },

    async submit() {
      this.captcha !== this.captchaChars.map(c => c.char).join('') ? this.captchaError = true : this.captchaError = false
      const {valid} = await this.$refs.form.validate()
      if (valid && !this.captchaError) {
        this.postPrivacyForm({
          data: {
            ...this.formDetails
          }
        }).then((response) => {
          this.formSubmit = true
          this.error = response.data.error
        })
      }
    },

    ...mapActions([
      'getLocaleKeys',
      'postPrivacyForm'
    ])
  }
}
</script>

<style lang="scss" scoped>
.captcha {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 50px;
  background-color: #f0f0f0;
  cursor: pointer;
}

.captcha-text {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  text-align: center;
  transform: rotate(-10deg);
  transform-origin: center;
}

p {
  margin-top: 10px;
  margin-bottom: 10px;
}

ul {
  margin-left: 25px;
  margin-top: 10px;
}
</style>
